module.exports = __webpack_public_path__ + "img/contact.5cad854f.svg";